import { Box, Typography } from '@mui/material'
import { lrHeaders, tripTableColumns } from './constants'
import { RenderTable } from '../Reports/analysisReport/summmaryTable'
import useToken from '../../helpers/useTokens'
import { safeAdd, withPercentWidths } from '../../common/mathHelper'
import { useLayoutEffect, useRef, useState } from 'react'

const TripPreview = ({ trip, lrRows = [] }) => {
  const { loginData } = useToken()
  const containerRef = useRef(null);
  const [tableHeight, setTableHeight] = useState(400);

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (!containerRef.current) return;

      const top = containerRef.current.getBoundingClientRect().top;

      setTableHeight(window.innerHeight - top - 20); // 20px bottom margin
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, [])
  const headers = lrHeaders
    .filter((column) => column.field !== 'select')
    .map((column) => ({
      ...column,
      headerName: column.header,
    }))
  if (!trip) return null

  const headerWithWidth = withPercentWidths(headers)
  const totalColumns = lrHeaders.reduce((acc, header) => {
    if (header.xlCol.dataType === 'quantity') {
      acc.push(header.field)
    }
    return acc
  }, [])
  const totalRow = lrRows.reduce(
    (acc, row) => {
      totalColumns.forEach((col) => {
        acc[col] = safeAdd(acc[col] || 0, row[col] || 0)
      })
      return acc
    },
    { dataType: 'total', LRNo: 'Total', colSpan: { LRNo: 7 }, align: { LRNo: 'right' } }
  )
  return (
    <Box className="render-table trip-view">
      <RenderTable header={tripTableColumns} data={[trip]} key1="siwk2" key2="sdkwwp" key3="sdkwod9" />
      <Typography
        sx={{
          mt: 2,
          mb: 1,
          px: 2,
          py: 1,
          background: '#eaf4ff',
          fontWeight: 700,
          fontSize: '16px',
        }}
      >
        Dispatch City : {loginData.strCityName}
        {'  |  '}
        Dispatch Branch : {loginData.strBranchName}
      </Typography>
      <Box ref={containerRef}
        sx={{ overflowX: 'scroll', height: tableHeight }}>
        <RenderTable header={headerWithWidth} data={[...lrRows, totalRow]} key1="fdr4se3" key2="fg4eswr3" key3="rwd3fef3" />
      </Box>
    </Box>
  )
}

export default TripPreview
